module.exports = __webpack_public_path__ + "media/src/images/icons/inbox-30c40f083823be5af72f6ab519e390b1.svg";